import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Page extends Component {
    static MainArea({ children }){
        return (
            <div className="main">{children}</div>
        );
    }
    static Sidebar({ children }){
        return (
            <div className="sidebar">{children}</div>
        );
    }

    render() {
        return (
            <div className="page">{this.props.children}</div>
        );
    }
}

Page.propTypes = {
    children: PropTypes.any,
}


// WEBPACK FOOTER //
// ./src/shared/components/Page.js